// LoaderContext.js
import React, { createContext, useContext, useState } from "react";
import { GeneralLoader } from "./GeneralLoader";

// Create a context for the loader
const LoaderContext = createContext();

// Loader Provider component
export const GeneralLoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Function to show the loader
  const showLoader = () => setIsLoading(true);

  // Function to hide the loader
  const hideLoader = () => setIsLoading(false);

  // Provide the loader state and control functions to children
  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}
      {isLoading && <GeneralLoader />}{" "}
      {/* Render the loader if isLoading is true */}
    </LoaderContext.Provider>
  );
};

// Custom hook to use the Loader context
export const useLoader = () => {
  return useContext(LoaderContext);
};
